import React, { Component } from "react";
import "./MainAppContainer.css";
import { translations } from "./assets/translations";
import { B2B_PROXY } from "./assets/config";
import FetchItineraries from "../components/FetchItineraries";
import Menu from "../components/Menu";
import VoucherDisplay from "../components/VoucherDisplay";
import History from "../components/History";
import ManualEntry from "../components/ManualEntry";
import SearchReservation from "../components/SearchReservation";
import ReservationDetails from "../components/ReservationDetails";
import Reports from "../components/Reports";
import axios from "axios";
import { Loader } from "react-overlay-loader";
import { Col } from "react-bootstrap";
import "react-overlay-loader/styles.css";
import { ToastContainer, ToastStore } from "react-toasts";
import EditTicket from "../components/EditTicket";
import PrinterSelection from "../components/PrinterSelection";

export default class MainAppContainer extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.handleClickOnItinerary = this.handleClickOnItinerary.bind(this);
    this.fetchReservation = this.fetchReservation.bind(this);
    this.onClickClearButton = this.onClickClearButton.bind(this);
    this.onChangeCompany = this.onChangeCompany.bind(this);
    this.validateSearch = this.validateSearch.bind(this);
    this.issueBoardingPasses = this.issueBoardingPasses.bind(this);
    this.cancelBoardingPasses = this.cancelBoardingPasses.bind(this);
    this.onClickReloadRoutesButton = this.onClickReloadRoutesButton.bind(this);
    this.onClickHistoryButton = this.onClickHistoryButton.bind(this);
    this.onCloseHistoryModal = this.onCloseHistoryModal.bind(this);
    this.onCloseManualEntry = this.onCloseManualEntry.bind(this);
    this.onCloseDisplayVouchers = this.onCloseDisplayVouchers.bind(this);
    this.onCloseEditTicket = this.onCloseEditTicket.bind(this);
    this.onClickManualEntryButton = this.onClickManualEntryButton.bind(this);
    this.onClickEditTicketButton = this.onClickEditTicketButton.bind(this);
    this.handleItineraries = this.handleItineraries.bind(this);
    this.onClickManualEntryPassenger =
      this.onClickManualEntryPassenger.bind(this);
    this.onClickReportsButton = this.onClickReportsButton.bind(this);
    this.onClickPrintSelection = this.onClickPrintSelection.bind(this);
    this.changeSelectedDevice = this.changeSelectedDevice.bind(this);
    this.onClickManualEntryVehicle = this.onClickManualEntryVehicle.bind(this);
    this.handleChangeOfManualEntryRadioButton =
      this.handleChangeOfManualEntryRadioButton.bind(this);
    this.handleChangeOfInputSearchFields =
      this.handleChangeOfInputSearchFields.bind(this);
    this.writeToSelectedPrinter = this.writeToSelectedPrinter.bind(this);
    this.setupPrinter = this.setupPrinter.bind(this);
    this.errorCallback = this.errorCallback.bind(this);
    this.handleChangeOfHistoryRadioButtons =
      this.handleChangeOfHistoryRadioButtons.bind(this);
    this.handlePersonCheckboxChange =
      this.handlePersonCheckboxChange.bind(this);
    this.handleVehicleCheckboxChange =
      this.handleVehicleCheckboxChange.bind(this);
    this.handlePersonSelectAllButton =
      this.handlePersonSelectAllButton.bind(this);
    this.handleVehicleSelectAllButton =
      this.handleVehicleSelectAllButton.bind(this);
    this.handleChangeOfInputTicketEmail =
      this.handleChangeOfInputTicketEmail.bind(this);
    this.handleChangeOfInputTicketPhone =
      this.handleChangeOfInputTicketPhone.bind(this);
    this.handleChangeOfInputTicketVehicleEmail =
      this.handleChangeOfInputTicketVehicleEmail.bind(this);
    this.handleChangeOfInputTicketVehiclePhone =
      this.handleChangeOfInputTicketVehiclePhone.bind(this);
    this.printReservationHistoryToXlsx =
      this.printReservationHistoryToXlsx.bind(this);
    this.handleChangeOfCheckpoint = this.handleChangeOfCheckpoint.bind(this);
    this.lockTrip = this.lockTrip.bind(this);
    this.deleteBooking = this.deleteBooking.bind(this);
    this.state = {
      isMRZMandatory: "0",
      lang: this.props.lang,
      loadingSpinner: false,
      displayReservationResults: false,
      isPersonSelectAllToggled: false,
      isVehicleSelectAllToggled: false,
      isHistoryModalOpen: false,
      isManualEntryOpen: false,
      isEditTicketOpen: false,
      manualEntryPassenger: true,
      manualEntryVehicle: false,
      isButtonDisabled: true,
      hasCancelledTickets: false,
      hasPersonVouchers: false,
      displayVouchers: false,
      displayVouchersConfirmed: false,
      userHasInsertedAllData: false,
      OpenReports: false,
      OpenPrinters: false,
      CItineraries: false,
      DItineraries: false,
      hasSelectedTickets: false,
      editPerson: false,
      shouldUpdateHistory: false,
      selectedItineraryIndex: null,
      firstNewTicketIndex: null,
      manualEntryRadioValue: "",
      selectedItineraryID: "",
      selectedSailID: "",
      reservationNumber: "",
      surnameOrPlate: "",
      reader: "",
      companyAbbreviation: "",
      ticketNumber: "",
      personBoardingPassesIssued: "",
      checkedInPassengers: "",
      vehicleBoardingPassesIssued: "",
      checkedInVehicles: "",
      confirmedPassengers: "",
      confirmedVehicles: "",
      historyType: "TicketExtendedHistory_BRD",
      itineraries: [],
      filteredItinerariesByCompany: [],
      personTickets: [],
      vehicleTickets: [],
      selectedPersonTickets: [],
      selectedVehicleTickets: [],
      ticketEmails: [],
      ticketPhoneNumbers: [],
      ticketVehicleEmails: [],
      ticketVehiclePhoneNumbers: [],
      vouchers: [],
      tripData: [],
      boardingCardVouchers: [],
      tripDataPerson: [],
      tripDataVehicle: [],
      reservationHistory: [],
      noDuplicateCompanyAbbreviations: [],
      printedBoardIds: [],
      editData: [],
      IssueTickets: [],
      selectedDevice: null,
      devices: [],
      bookIDsForDeleteAll: [],
      bookIDsVehForDeleteAll: [],
      credentials: {
        userid: localStorage.getItem("userid"),
        UserName: localStorage.getItem("UserName"),
        Password: localStorage.getItem("Password"),
        lang: "EN",
      },
      selectedCheckpoint: "",
      CheckPoints: [],
      checkValidity: [],
      // Initialize Rights Flags in state
      CanTestPrint: false,
      CanUseMRZ: false,
      CanIssueBP: false,
      CanCloseTripForBP: false,
      CanCancelBP: false,
      CanDeleteReservation: false,
      CanEditBoardingPass: false,
      CanManuallyInsert: false,
      CanTestPrintForIssueBc: false,
      CanDoCheckin: false,
      CanDoCheckout: false,
      CanCheckBP: false,
      CanSendOffLineData: false,
      CanCloseTripForPDA: false,
      CanIssueAMPDoc: false,
      CanReprintBoardingPass: false,
      CanCreateBGR: false,
      CanListViewBGR: false,
      CanEditBGR: false,
      CanEditOneMoreTime: false,
      CanAddBGRWithMRZ: false,
      CanSubmitBGR: false,
      CanUnSubmitBGR: false,
      CanCloseBGR: false,
      CanRejectBGR: false,
    };
  }

  componentDidMount() {
    // List of all rights we need to pull from localStorage
    const rightsKeys = [
      "CanTestPrint",
      "CanUseMRZ",
      "CanIssueBP",
      "CanCloseTripForBP",
      "CanCancelBP",
      "CanDeleteReservation",
      "CanEditBoardingPass",
      "CanManuallyInsert",
      "CanTestPrintForIssueBc",
      "CanDoCheckin",
      "CanDoCheckout",
      "CanCheckBP",
      "CanSendOffLineData",
      "CanCloseTripForPDA",
      "CanIssueAMPDoc",
      "CanReprintBoardingPass",
      "CanCreateBGR",
      "CanListViewBGR",
      "CanEditBGR",
      "CanEditOneMoreTime",
      "CanAddBGRWithMRZ",
      "CanSubmitBGR",
      "CanUnSubmitBGR",
      "CanCloseBGR",
      "CanRejectBGR"
    ];

    const rightsUpdate = {};
    rightsKeys.forEach(key => {
      // Convert the string "true" from localStorage back to a boolean
      rightsUpdate[key] = localStorage.getItem(key) === "true";
    });

    this.setState(rightsUpdate);

    if (!window.BrowserPrint) {
        const script = document.createElement('script');
        script.src = 'BrowserPrint-3.1.250.min.js';
        script.async = true;
        document.body.appendChild(script);
        
        script.onload = () => {
            if (window.BrowserPrint) {
                this.setupPrinter();
            }
        };
    }

    if (
      localStorage.getItem("Authenticated") === "false" ||
      localStorage.getItem("Authenticated") === null
    ) {
      this.props.history.push("/");
    } else {
      this.props.userHasAuthenticated();
    }
    this.setState({ loadingSpinner: true });
    axios
      .post(B2B_PROXY + "/itineraryInfo", this.state.credentials)
      .then((res) => {
        var removeDuplicateCompanyAbbreviations = [];
        var companyAbbreviations = new Set();
        let itinerariesMap = [];
        if (res.data.statusData.StatusCode === "000") {
          itinerariesMap = res.data.itineraryInfo.map((obj) => ({
            ItineraryID: obj.ItineraryID,
            SailID: obj.SailID,
            DeparturePortDescription: obj.DeparturePortDescription,
            VesselName: obj.VesselName,
            CompanyDescription: obj.CompanyDescription,
            CompanyCode: obj.CompanyCode,
            ArrivalPortDescription: obj.ArrivalPortDescription,
            DepartureDate: obj.DepartureDate,
            DepartureTime: obj.DepartureTime,
            ArrivalDate: obj.ArrivalDate,
            ArrivalTime: obj.ArrivalTime,
            AvailablePassengers: obj.AvailablePassengers,
            AvailableVehicles: obj.AvailableVehicles,
            OccupiedPassengers: obj.OccupiedPassengers,
            OccupiedVehicles: obj.OccupiedVehicles,
            CheckedInPassengers: obj.CheckedInPassengers,
            CheckedInVehicles: obj.CheckedInVehicles,
            RemainderPassengers: obj.RemainderPassengers,
            RemainderVehicles: obj.RemainderVehicles,
            ConfirmedPassengerCounter: obj.ConfirmedPassengerCounter,
            ConfirmedVehicleCounter: obj.ConfirmedVehicleCounter,
            ConfirmedPassengerRemaining: obj.ConfirmedPassengerRemaining,
            ConfirmedVehicleRemaining: obj.ConfirmedVehicleRemaining,
            ConfirmedPassengerRemainingThreshold:
              obj.ConfirmedPassengerRemainingThreshold,
            ConfirmedVehicleRemainingThreshold:
              obj.ConfirmedVehicleRemainingThreshold,
          }));

          for (let i = 0; i < itinerariesMap.length; i++) {
            if (!companyAbbreviations.has(itinerariesMap[i].CompanyCode)) {
              removeDuplicateCompanyAbbreviations.push([
                itinerariesMap[i].CompanyCode,
                itinerariesMap[i],
              ]);
              companyAbbreviations.add(itinerariesMap[i].CompanyCode);
            }
          }
          this.setState({
            noDuplicateCompanyAbbreviations:
              removeDuplicateCompanyAbbreviations,
          });
          this.setState({ itineraries: itinerariesMap });
          this.setState({ loadingSpinner: false });
        } else {
          this.setState({
            noDuplicateCompanyAbbreviations:
              removeDuplicateCompanyAbbreviations,
          });
          this.setState({ itineraries: itinerariesMap });
          this.setState({ loadingSpinner: false });
          ToastStore.error(res.data.statusData.StatusMessage, 5000);
        }
      })
      .catch(() => {
        ToastStore.error(translations[this.props.lang]["Network Error"], 5000);
        this.setState({ loadingSpinner: false });
      });
  }

  setupPrinter() {
    window.BrowserPrint.getDefaultDevice("printer", (device) => {
      this.setState({ selectedDevice: device, devices: [device] });
    }, (error) => {
      console.log("Error getting Default devices " + error);
    });

    window.BrowserPrint.getLocalDevices((deviceList) => {
      const { selectedDevice, devices } = this.state;
      const filteredDevices = deviceList.filter(device => !selectedDevice || device.uid !== selectedDevice.uid);
      this.setState({ devices: [...devices, ...filteredDevices] });
    }, () => {
      console.log("Error getting local devices");
    }, "printer");
  }

  writeToSelectedPrinter(dataToWrite) {
    const { selectedDevice } = this.state;
    if (selectedDevice) {
      selectedDevice.send(dataToWrite, undefined, this.errorCallback);
    } else {
      console.log(dataToWrite)
      ToastStore.error("No printer selected");
    }
  }

  errorCallback = (errorMessage) => {
    ToastStore.error("Error: " + errorMessage);	
  }

  handleChangeOfInputSearchFields(event) {
    let fieldName = event.target.name;
    let fieldValue = event.target.value;
    this.setState({ [fieldName]: fieldValue });
  }

  handleChangeOfHistoryRadioButtons = (changeEvent) => {
    this.setState(
      {
        historyType: changeEvent.target.value,
      },
      () => {
        this.onClickHistoryButton();
      }
    );
  };

  handleChangeOfInputTicketEmail(event, index) {
    let ticketEmails = [...this.state.ticketEmails];
    let ticketVehicleEmails = [...this.state.ticketVehicleEmails];
    let item = { ...ticketEmails[index] };
    item = event.target.value;
    if (index === this.state.firstNewTicketIndex) {
      for (let i = 0; i < this.state.ticketEmails.length; i++) {
        if (this.state.personTickets[i].ConfirmationStatus !== "Canceled")
          ticketEmails[i] = item;
      }
      if (this.state.vehicleTickets.length > 0)
        for (let i = 0; i < this.state.ticketVehicleEmails.length; i++) {
          if (this.state.vehicleTickets[i].ConfirmationStatus !== "Canceled")
            ticketVehicleEmails[i] = item;
        }
    }
    ticketEmails[index] = item;
    this.setState({ ticketVehicleEmails });
    this.setState({ ticketEmails }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            (this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
            (this.state.ticketPhoneNumbers[i].length > 0 &&
              this.state.ticketPhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            (this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
            (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
              this.state.ticketVehiclePhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handleChangeOfInputTicketPhone(event, index) {
    let ticketPhoneNumbers = [...this.state.ticketPhoneNumbers];
    let ticketVehiclePhoneNumbers = [...this.state.ticketVehiclePhoneNumbers];
    let item = { ...ticketPhoneNumbers[index] };
    item = event.target.value;
    if (/^[0-9\b]+$/.test(item) || item.length === 0) {
      ticketPhoneNumbers[index] = item;
      if (index === this.state.firstNewTicketIndex) {
        for (let i = 0; i < this.state.ticketPhoneNumbers.length; i++) {
          if (this.state.personTickets[i].ConfirmationStatus !== "Canceled")
            ticketPhoneNumbers[i] = item;
        }

        if (this.state.vehicleTickets.length > 0)
          for (
            let i = 0;
            i < this.state.ticketVehiclePhoneNumbers.length;
            i++
          ) {
            if (this.state.vehicleTickets[i].ConfirmationStatus !== "Canceled")
              ticketVehiclePhoneNumbers[i] = item;
          }
      }
    }
    this.setState({ ticketVehiclePhoneNumbers });
    this.setState({ ticketPhoneNumbers }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            (this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
            (this.state.ticketPhoneNumbers[i].length > 0 &&
              this.state.ticketPhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            (this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
            (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
              this.state.ticketVehiclePhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handleChangeOfInputTicketVehicleEmail(event, index) {
    let ticketVehicleEmails = [...this.state.ticketVehicleEmails];
    let item = { ...ticketVehicleEmails[index] };
    item = event.target.value;
    ticketVehicleEmails[index] = item;
    this.setState({ ticketVehicleEmails }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            (this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
            (this.state.ticketPhoneNumbers[i].length > 0 &&
              this.state.ticketPhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            (this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
            (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
              this.state.ticketVehiclePhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handleChangeOfInputTicketVehiclePhone(event, index) {
    let ticketVehiclePhoneNumbers = [...this.state.ticketVehiclePhoneNumbers];
    let item = { ...ticketVehiclePhoneNumbers[index] };
    item = event.target.value;
    if (/^[0-9\b]+$/.test(item) || item.length === 0)
      ticketVehiclePhoneNumbers[index] = item;
    this.setState({ ticketVehiclePhoneNumbers }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            (this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
            (this.state.ticketPhoneNumbers[i].length > 0 &&
              this.state.ticketPhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            (this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
            (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
              this.state.ticketVehiclePhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handlePersonCheckboxChange(index) {
    let selectedPersonTickets = [...this.state.selectedPersonTickets];
    let item = { ...selectedPersonTickets[index] };
    item = !this.state.selectedPersonTickets[index];
    selectedPersonTickets[index] = item;

    if (item === true) {
      this.setState({ editPerson: true });
      this.setState({ editData: this.state.personTickets[index] });
    }

    this.setState({ selectedPersonTickets }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            (this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
            (this.state.ticketPhoneNumbers[i].length > 0 &&
              this.state.ticketPhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            (this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
            (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
              this.state.ticketVehiclePhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons || hasSelectedVehicles) {
        this.setState({ hasSelectedTickets: true });
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handleVehicleCheckboxChange(index) {
    let selectedVehicleTickets = [...this.state.selectedVehicleTickets];
    let item = { ...selectedVehicleTickets[index] };
    item = !this.state.selectedVehicleTickets[index];
    selectedVehicleTickets[index] = item;

    if (item === true) {
      this.setState({ editPerson: false });
      this.setState({ editData: this.state.vehicleTickets[index] });
    }

    this.setState({ selectedVehicleTickets }, () => {
      let hasSelectedPersons = false;
      let shouldNotIssueBoardingPassesFlag1 = false;
      for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
        if (this.state.selectedPersonTickets[i] === true) {
          hasSelectedPersons = true;
          if (
            (this.state.ticketEmails[i] === "" &&
              this.state.ticketPhoneNumbers[i] === "") ||
            (this.state.ticketEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketEmails[i]
              )) ||
            (this.state.ticketPhoneNumbers[i].length > 0 &&
              this.state.ticketPhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag1 = true;
        }
      }
      let shouldNotIssueBoardingPassesFlag2 = false;
      let hasSelectedVehicles = false;
      for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
        if (this.state.selectedVehicleTickets[i] === true) {
          hasSelectedVehicles = true;
          if (
            (this.state.ticketVehicleEmails[i] === "" &&
              this.state.ticketVehiclePhoneNumbers[i] === "") ||
            (this.state.ticketVehicleEmails[i].length > 0 &&
              !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.ticketVehicleEmails[i]
              )) ||
            (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
              this.state.ticketVehiclePhoneNumbers[i].length < 10)
          )
            shouldNotIssueBoardingPassesFlag2 = true;
        }
      }

      if (hasSelectedPersons || hasSelectedVehicles) {
        this.setState({ hasSelectedTickets: true });
      }

      if (hasSelectedPersons) {
        if (!shouldNotIssueBoardingPassesFlag1) {
          if (hasSelectedVehicles) {
            if (!shouldNotIssueBoardingPassesFlag2) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else if (hasSelectedVehicles) {
        if (!shouldNotIssueBoardingPassesFlag2) {
          if (hasSelectedPersons) {
            if (!shouldNotIssueBoardingPassesFlag1) {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            } else {
              this.setState({ disableIssueBoardingPassesButton: true });
            }
          } else {
            this.setState({ userHasInsertedAllData: true });
            if (this.state.selectedItineraryID !== "")
              this.setState({ disableIssueBoardingPassesButton: false });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      } else {
        this.setState({ disableIssueBoardingPassesButton: true });
      }
    });
  }

  handlePersonSelectAllButton() {
    let value = !this.state.isPersonSelectAllToggled,
      size = this.state.personTickets.length,
      array = new Array(size);
    for (let i = 0; i < size; i++) {
      if (this.state.personTickets[i].ConfirmationStatus === "Canceled") {
        array[i] = false;
      } else {
        array[i] = value;
      }
    }
    this.setState({ selectedPersonTickets: array });
    this.setState(
      {
        isPersonSelectAllToggled: !this.state.isPersonSelectAllToggled,
      },
      () => {
        let hasSelectedPersons = false;
        let shouldNotIssueBoardingPassesFlag1 = false;
        for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
          if (this.state.selectedPersonTickets[i] === true) {
            hasSelectedPersons = true;
            if (
              (this.state.ticketEmails[i] === "" &&
                this.state.ticketPhoneNumbers[i] === "") ||
              (this.state.ticketEmails[i].length > 0 &&
                !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                  this.state.ticketEmails[i]
                )) ||
              (this.state.ticketPhoneNumbers[i].length > 0 &&
                this.state.ticketPhoneNumbers[i].length < 10)
            )
              shouldNotIssueBoardingPassesFlag1 = true;
          }
        }
        let shouldNotIssueBoardingPassesFlag2 = false;
        let hasSelectedVehicles = false;
        for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
          if (this.state.selectedVehicleTickets[i] === true) {
            hasSelectedVehicles = true;
            if (
              (this.state.ticketVehicleEmails[i] === "" &&
                this.state.ticketVehiclePhoneNumbers[i] === "") ||
              (this.state.ticketVehicleEmails[i].length > 0 &&
                !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                  this.state.ticketVehicleEmails[i]
                )) ||
              (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                this.state.ticketVehiclePhoneNumbers[i].length < 10)
            )
              shouldNotIssueBoardingPassesFlag2 = true;
          }
        }

        if (hasSelectedPersons) {
          if (!shouldNotIssueBoardingPassesFlag1) {
            if (hasSelectedVehicles) {
              if (!shouldNotIssueBoardingPassesFlag2) {
                this.setState({ userHasInsertedAllData: true });
                if (this.state.selectedItineraryID !== "")
                  this.setState({ disableIssueBoardingPassesButton: false });
              } else {
                this.setState({ disableIssueBoardingPassesButton: true });
              }
            } else {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            }
          } else {
            this.setState({ disableIssueBoardingPassesButton: true });
          }
        } else if (hasSelectedVehicles) {
          if (!shouldNotIssueBoardingPassesFlag2) {
            if (hasSelectedPersons) {
              if (!shouldNotIssueBoardingPassesFlag1) {
                this.setState({ userHasInsertedAllData: true });
                if (this.state.selectedItineraryID !== "")
                  this.setState({ disableIssueBoardingPassesButton: false });
              } else {
                this.setState({ disableIssueBoardingPassesButton: true });
              }
            } else {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            }
          } else {
            this.setState({ disableIssueBoardingPassesButton: true });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      }
    );
  }

  handleVehicleSelectAllButton() {
    let value = !this.state.isVehicleSelectAllToggled,
      size = this.state.vehicleTickets.length,
      array = new Array(size);
    for (let i = 0; i < size; i++) {
      if (this.state.vehicleTickets[i].ConfirmationStatus === "Canceled") {
        array[i] = false;
      } else {
        array[i] = value;
      }
    }
    this.setState({ selectedVehicleTickets: array });
    this.setState(
      {
        isVehicleSelectAllToggled: !this.state.isVehicleSelectAllToggled,
      },
      () => {
        let hasSelectedPersons = false;
        let shouldNotIssueBoardingPassesFlag1 = false;
        for (let i = 0; i < this.state.selectedPersonTickets.length; i++) {
          if (this.state.selectedPersonTickets[i] === true) {
            hasSelectedPersons = true;
            if (
              (this.state.ticketEmails[i] === "" &&
                this.state.ticketPhoneNumbers[i] === "") ||
              (this.state.ticketEmails[i].length > 0 &&
                !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                  this.state.ticketEmails[i]
                )) ||
              (this.state.ticketPhoneNumbers[i].length > 0 &&
                this.state.ticketPhoneNumbers[i].length < 10)
            )
              shouldNotIssueBoardingPassesFlag1 = true;
          }
        }
        let shouldNotIssueBoardingPassesFlag2 = false;
        let hasSelectedVehicles = false;
        for (let i = 0; i < this.state.selectedVehicleTickets.length; i++) {
          if (this.state.selectedVehicleTickets[i] === true) {
            hasSelectedVehicles = true;
            if (
              (this.state.ticketVehicleEmails[i] === "" &&
                this.state.ticketVehiclePhoneNumbers[i] === "") ||
              (this.state.ticketVehicleEmails[i].length > 0 &&
                !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                  this.state.ticketVehicleEmails[i]
                )) ||
              (this.state.ticketVehiclePhoneNumbers[i].length > 0 &&
                this.state.ticketVehiclePhoneNumbers[i].length < 10)
            )
              shouldNotIssueBoardingPassesFlag2 = true;
          }
        }

        if (hasSelectedPersons) {
          if (!shouldNotIssueBoardingPassesFlag1) {
            if (hasSelectedVehicles) {
              if (!shouldNotIssueBoardingPassesFlag2) {
                this.setState({ userHasInsertedAllData: true });
                if (this.state.selectedItineraryID !== "")
                  this.setState({ disableIssueBoardingPassesButton: false });
              } else {
                this.setState({ disableIssueBoardingPassesButton: true });
              }
            } else {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            }
          } else {
            this.setState({ disableIssueBoardingPassesButton: true });
          }
        } else if (hasSelectedVehicles) {
          if (!shouldNotIssueBoardingPassesFlag2) {
            if (hasSelectedPersons) {
              if (!shouldNotIssueBoardingPassesFlag1) {
                this.setState({ userHasInsertedAllData: true });
                if (this.state.selectedItineraryID !== "")
                  this.setState({ disableIssueBoardingPassesButton: false });
              } else {
                this.setState({ disableIssueBoardingPassesButton: true });
              }
            } else {
              this.setState({ userHasInsertedAllData: true });
              if (this.state.selectedItineraryID !== "")
                this.setState({ disableIssueBoardingPassesButton: false });
            }
          } else {
            this.setState({ disableIssueBoardingPassesButton: true });
          }
        } else {
          this.setState({ disableIssueBoardingPassesButton: true });
        }
      }
    );
  }

  handleChangeOfManualEntryRadioButton = (event) => {
    this.setState({ manualEntryRadioValue: event.target.value });
  };

  handleClickOnItinerary = (e, index) => {
    var selectedItineraryArray = e.target.id.split("@");
    this.setState({ selectedItineraryID: selectedItineraryArray[0] });
    this.setState({ companyAbbreviation: selectedItineraryArray[2] });
    this.setState({ selectedItineraryIndex: index });
    this.setState({
      personBoardingPassesIssued:
        " " + selectedItineraryArray[5] + " / " + selectedItineraryArray[3],
    });
    this.setState({
      checkedInPassengers:
        " " + selectedItineraryArray[7] + " / " + selectedItineraryArray[9],
    });
    this.setState({
      vehicleBoardingPassesIssued:
        " " + selectedItineraryArray[6] + " / " + selectedItineraryArray[4],
    });
    this.setState({
      checkedInVehicles:
        " " + selectedItineraryArray[8] + " / " + selectedItineraryArray[10],
    });
    this.setState({
      confirmedPassengers:
        " " + selectedItineraryArray[11] + " / " + selectedItineraryArray[13],
    });
    this.setState({
      confirmedVehicles:
        " " + selectedItineraryArray[12] + " / " + selectedItineraryArray[14],
    });
    this.setState({ selectedSailID: selectedItineraryArray[15] });
  };

  validateSearch = () => {
    if (
      this.state.selectedItineraryID !== "" &&
      this.state.companyAbbreviation !== ""
    ) {
      if (this.state.ticketNumber !== "" || this.state.reservationNumber !== "")
        return true;
    } else {
      if (this.state.selectedItineraryID === "") {
        ToastStore.error(
          translations[this.props.lang]["Please select an itinerary."],
          5000
        );
      }
      if (
        this.state.ticketNumber === "" &&
        this.state.reservationNumber === ""
      ) {
        ToastStore.error(
          translations[this.props.lang]["Please type in a ticket number."],
          5000
        );
      }
      if (this.state.companyAbbreviation === "") {
        ToastStore.error(
          translations[this.props.lang]["Please type in or select a company"],
          5000
        );
        return false;
      }
    }
  };

  fetchReservation = () => {
    if (!this.state.displayReservationResults && this.state.isManualEntryOpen) {
      this.setState({ isManualEntryOpen: false });
      return;
    }
    this.setState({ isEditTicketOpen: false });
    this.setState({ isManualEntryOpen: false });

    if (this.state.ticketNumber === "") {
      const headerData = {
        userid: this.state.credentials.userid,
        lang: this.props.lang,
        Password: this.state.credentials.Password,
        UserName: this.state.credentials.UserName,
        itineraryID: this.state.selectedItineraryID,
        bookingNumber: this.state.reservationNumber.trim(),
      };
      this.setState({ loadingSpinner: true });
      axios.post(B2B_PROXY + "/ticketEnquiry", headerData).then((res) => {
        if (res.data[0] !== "000") {
          ToastStore.error(res.data[1], 5000);
          this.setState({ loadingSpinner: false });
          return;
        }
        const personTickets = res.data[2].map((obj) => ({
          Surname: obj.Surname,
          ItineraryID: obj.ItineraryID,
          Name: obj.Name,
          MaidenName: obj.MaidenName,
          AgeCategory: obj.AgeCategory,
          Gender: obj.Gender,
          BirthDate: obj.BirthDate,
          BirthPlace: obj.BirthPlace,
          Nationality: obj.Nationality,
          DocType: obj.DocType,
          PassportNumber: obj.PassportNumber,
          PassportDelDate: obj.PassportDelDate,
          VisaNumber: obj.VisaNumber,
          Occupation: obj.Occupation,
          SpecialServicesReq: obj.SpecialServicesReq,
          AccommodationType: obj.AccommodationType,
          CabinSeatNumber: obj.CabinSeatNumber,
          Berth: obj.Berth,
          TicketNumber: obj.TicketNumber,
          InitialTicketIssuer: obj.InitialTicketIssuer,
          CountryOfUsualResidence: obj.CountryOfUsualResidence,
          GoingTo: obj.GoingTo,
          CommingFrom: obj.CommingFrom,
          AddressInMorocco: obj.AddressInMorocco,
          PhoneDuringStay: obj.PhoneDuringStay,
          MainReasonForVisit: obj.MainReasonForVisit,
          TicketIssueDate: obj.TicketIssueDate,
          TicketExpirationDate: obj.TicketExpirationDate,
          BookID: obj.BookID,
          BoardID: obj.BoardID,
          BoardStatus: obj.BoardStatus,
          ConfirmationID: obj.ConfirmationID,
          ConfirmationStatus: obj.ConfirmationStatus,
          Email: obj.Email,
          IsMRZScanned: obj.IsMRZScanned,
        }));
        this.setState({ 
          personTickets: personTickets,
          isMRZMandatory: res.data[5] || "0"
        });

        const vehicleTickets = res.data[3].map((obj) => ({
          ItineraryID: obj.ItineraryID,
          VehicleType: obj.VehicleType,
          Length: obj.Length,
          Height: obj.Height,
          RegistrationNumber: obj.RegistrationNumber,
          DriverName: obj.DriverName,
          Brand: obj.Brand,
          Model: obj.Model,
          TicketNumber: obj.TicketNumber,
          InitialTicketIssuer: obj.InitialTicketIssuer,
          TicketIssueDate: obj.TicketIssueDate,
          TicketExpirationDate: obj.TicketExpirationDate,
          BookID: obj.BookID,
          BoardID: obj.BoardID,
          BoardStatus: obj.BoardStatus,
          ConfirmationID: obj.ConfirmationID,
          ConfirmationStatus: obj.ConfirmationStatus,
        }));

        this.setState({ vehicleTickets: vehicleTickets });

        let tripData = res.data[4].map((obj) => ({
          SailID: obj.SailID,
          BookID: obj.BookID,
          ItineraryID: obj.ItineraryID,
          VesselIMO: obj.VesselIMO,
          VesselName: obj.VesselName,
          CompanyCode: obj.CompanyCode,
          CompanyDescription: obj.CompanyDescription,
          DeparturePortCode: obj.DeparturePortCode,
          DeparturePortDescription: obj.DeparturePortDescription,
          DepartureDate: obj.DepartureDate,
          DepartureTime: obj.DepartureTime,
          ArrivalPortCode: obj.ArrivalPortCode,
          ArrivalPortDescription: obj.ArrivalPortDescription,
          ArrivalDate: obj.ArrivalDate,
          ArrivalTime: obj.ArrivalTime,
        }));

        this.setState({ tripData: tripData });
        const bookIDsForDeleteAll = res.data[2].map((obj) => ({
          BookIDforDeleteAll: obj.BookID,
        }));
        this.setState({ bookIDsForDeleteAll: bookIDsForDeleteAll });
        const bookIDsVehForDeleteAll = res.data[3].map((obj) => ({
          BookIDVehforDeleteAll: obj.BookID,
        }));
        this.setState({ bookIDsVehForDeleteAll: bookIDsVehForDeleteAll });
        for (let i = 0; i < personTickets.length; i++) {
          let ticketEmails = [...this.state.ticketEmails];
          ticketEmails[i] = "";
          this.setState({ ticketEmails });
        }
        for (let i = 0; i < personTickets.length; i++) {
          let ticketPhoneNumbers = [...this.state.ticketPhoneNumbers];
          ticketPhoneNumbers[i] = "";
          this.setState({ ticketPhoneNumbers });
        }
        for (let i = 0; i < vehicleTickets.length; i++) {
          let ticketVehicleEmails = [...this.state.ticketVehicleEmails];
          ticketVehicleEmails[i] = "";
          this.setState({ ticketVehicleEmails });
        }
        for (let i = 0; i < vehicleTickets.length; i++) {
          let ticketVehiclePhoneNumbers = [
            ...this.state.ticketVehiclePhoneNumbers,
          ];
          ticketVehiclePhoneNumbers[i] = "";
          this.setState({ ticketVehiclePhoneNumbers });
        }

        let value = false,
          size = personTickets.length,
          emptyFalseArray = Array.apply(null, { length: size }).map(
            function () {
              return value;
            }
          );
        this.setState({ selectedPersonTickets: emptyFalseArray });
        size = vehicleTickets.length;
        emptyFalseArray = Array.apply(null, { length: size }).map(function () {
          return value;
        });
        this.setState({ selectedVehicleTickets: emptyFalseArray });
        this.setState({ displayReservationResults: true });
        this.setState({ displayItineraries: true });
        this.setState({ loadingSpinner: false });

        if (personTickets.length === 0 && vehicleTickets.length === 0) {
          this.setState({ displayReservationResults: false });
          this.setState({ displayItineraries: false });
          ToastStore.error(translations[this.props.lang]["No Data"], 5000);
        }

        let firstNewTicketIndex = null;
        for (let i = 0; i < personTickets.length; i++) {
          firstNewTicketIndex = i;
          break;
        }

        this.setState({ firstNewTicketIndex });
        this.setState({
          isPersonSelectAllToggled: false,
        });
        this.setState({
          isVehicleSelectAllToggled: false,
        });

        if (personTickets.length > 0) {
          if (personTickets[0].ItineraryID === "0") {
            let bookIDArray = [];
            let bookIDVehicleArray = [];
            let pass = [];
            let veh = [];
            for (let i = 0; i < personTickets.length; i++) {
              bookIDArray.push(personTickets[i].BookID);
              pass.push(personTickets[i]);
            }

            for (let i = 0; i < vehicleTickets.length; i++) {
              bookIDVehicleArray.push(vehicleTickets[i].BookID);
              veh.push(vehicleTickets[i]);
            }

            const headerData = {
              userid: this.state.credentials.userid,
              lang: this.props.lang,
              Password: this.state.credentials.Password,
              UserName: this.state.credentials.UserName,
              itineraryID: this.state.selectedItineraryID,
              sailID: this.state.selectedSailID,
              bookingNumber: this.state.reservationNumber.trim(),
              companyCode: this.state.companyAbbreviation,
              bookIDArray: bookIDArray,
              bookIDVehicleArray: bookIDVehicleArray,
              passArray: pass,
              vehArray: veh,
              tripData: tripData,
            };
            this.setState({ loadingSpinner: true });
            axios.post(B2B_PROXY + "/openPost", headerData).then((res) => {
              this.setState({ loadingSpinner: false });
            });
          }
        } else {
          if (vehicleTickets[0].ItineraryID === "0") {
            let bookIDArray = [];
            let bookIDVehicleArray = [];
            let pass = [];
            let veh = [];
            for (let i = 0; i < personTickets.length; i++) {
              bookIDArray.push(personTickets[i].BookID);
              pass.push(personTickets[i]);
            }

            for (let i = 0; i < vehicleTickets.length; i++) {
              bookIDVehicleArray.push(vehicleTickets[i].BookID);
              veh.push(vehicleTickets[i]);
            }

            const headerData = {
              userid: this.state.credentials.userid,
              lang: this.props.lang,
              Password: this.state.credentials.Password,
              UserName: this.state.credentials.UserName,
              itineraryID: this.state.selectedItineraryID,
              sailID: this.state.selectedSailID,
              bookingNumber: this.state.reservationNumber.trim(),
              companyCode: this.state.companyAbbreviation,
              bookIDArray: bookIDArray,
              bookIDVehicleArray: bookIDVehicleArray,
              passArray: pass,
              vehArray: veh,
              tripData: tripData,
            };
            this.setState({ loadingSpinner: true });
            axios.post(B2B_PROXY + "/openPost", headerData).then((res) => {
              this.setState({ loadingSpinner: false });
            });
          }
        }
      });
    } else {
      const headerData = {
        userGroup: this.state.credentials.userid,
        lang: this.props.lang,
        password: this.state.credentials.Password,
        username: this.state.credentials.UserName,
        ItineraryID: this.state.selectedItineraryID,
        TicketNumberME: this.state.ticketNumber.trim(),
      };
      this.setState({ loadingSpinner: true });
      axios
        .post(B2B_PROXY + "/TicketEnquiryForTickNum", headerData)
        .then((res) => {
          if (res.data[0] !== "000") {
            ToastStore.error(res.data[1], 5000);
            this.setState({ loadingSpinner: false });
            return;
          }
          const personTickets = res.data[2].map((obj) => ({
            Surname: obj.Surname,
            ItineraryID: obj.ItineraryID,
            Name: obj.Name,
            MaidenName: obj.MaidenName,
            AgeCategory: obj.AgeCategory,
            Gender: obj.Gender,
            BirthDate: obj.BirthDate,
            BirthPlace: obj.BirthPlace,
            Nationality: obj.Nationality,
            DocType: obj.DocType,
            PassportNumber: obj.PassportNumber,
            PassportDelDate: obj.PassportDelDate,
            VisaNumber: obj.VisaNumber,
            Occupation: obj.Occupation,
            SpecialServicesReq: obj.SpecialServicesReq,
            AccommodationType: obj.AccommodationType,
            CabinSeatNumber: obj.CabinSeatNumber,
            Berth: obj.Berth,
            TicketNumber: obj.TicketNumber,
            InitialTicketIssuer: obj.InitialTicketIssuer,
            CountryOfUsualResidence: obj.CountryOfUsualResidence,
            GoingTo: obj.GoingTo,
            CommingFrom: obj.CommingFrom,
            AddressInMorocco: obj.AddressInMorocco,
            PhoneDuringStay: obj.PhoneDuringStay,
            MainReasonForVisit: obj.MainReasonForVisit,
            TicketIssueDate: obj.TicketIssueDate,
            TicketExpirationDate: obj.TicketExpirationDate,
            BookID: obj.BookID,
            BoardID: obj.BoardID,
            BoardStatus: obj.BoardStatus,
            ConfirmationStatus: obj.ConfirmationStatus,
            IsMRZScanned: obj.IsMRZScanned,
          }));
          this.setState({ 
            personTickets: personTickets,
            isMRZMandatory: res.data[6] || "0"
          });

          const vehicleTickets = res.data[3].map((obj) => ({
            ItineraryID: obj.ItineraryID,
            VehicleType: obj.VehicleType,
            Length: obj.Length,
            Height: obj.Height,
            RegistrationNumber: obj.RegistrationNumber,
            DriverName: obj.DriverName,
            Brand: obj.Brand,
            Model: obj.Model,
            TicketNumber: obj.TicketNumber,
            InitialTicketIssuer: obj.InitialTicketIssuer,
            TicketIssueDate: obj.TicketIssueDate,
            TicketExpirationDate: obj.TicketExpirationDate,
            BookID: obj.BookID,
            BoardID: obj.BoardID,
            BoardStatus: obj.BoardStatus,
            ConfirmationStatus: obj.ConfirmationStatus,
          }));
          this.setState({ vehicleTickets: vehicleTickets });
          const reservationNumber = res.data[4];
          this.setState({ reservationNumber: reservationNumber });
          //this.setState({ reservationNumber: res.data[4] });
          let tripData = res.data[5].map((obj) => ({
            SailID: obj.SailID,
            BookID: obj.BookID,
            ItineraryID: obj.ItineraryID,
            VesselIMO: obj.VesselIMO,
            VesselName: obj.VesselName,
            CompanyCode: obj.CompanyCode,
            CompanyDescription: obj.CompanyDescription,
            DeparturePortCode: obj.DeparturePortCode,
            DeparturePortDescription: obj.DeparturePortDescription,
            DepartureDate: obj.DepartureDate,
            DepartureTime: obj.DepartureTime,
            ArrivalPortCode: obj.ArrivalPortCode,
            ArrivalPortDescription: obj.ArrivalPortDescription,
            ArrivalDate: obj.ArrivalDate,
            ArrivalTime: obj.ArrivalTime,
          }));

          this.setState({ tripData: tripData });

          for (let i = 0; i < personTickets.length; i++) {
            let ticketEmails = [...this.state.ticketEmails];
            ticketEmails[i] = "";
            this.setState({ ticketEmails });
          }
          for (let i = 0; i < personTickets.length; i++) {
            let ticketPhoneNumbers = [...this.state.ticketPhoneNumbers];
            ticketPhoneNumbers[i] = "";
            this.setState({ ticketPhoneNumbers });
          }
          for (let i = 0; i < vehicleTickets.length; i++) {
            let ticketVehicleEmails = [...this.state.ticketVehicleEmails];
            ticketVehicleEmails[i] = "";
            this.setState({ ticketVehicleEmails });
          }
          for (let i = 0; i < vehicleTickets.length; i++) {
            let ticketVehiclePhoneNumbers = [
              ...this.state.ticketVehiclePhoneNumbers,
            ];
            ticketVehiclePhoneNumbers[i] = "";
            this.setState({ ticketVehiclePhoneNumbers });
          }

          let value = false,
            size = personTickets.length,
            emptyFalseArray = Array.apply(null, { length: size }).map(
              function () {
                return value;
              }
            );
          this.setState({ selectedPersonTickets: emptyFalseArray });
          size = vehicleTickets.length;
          emptyFalseArray = Array.apply(null, { length: size }).map(
            function () {
              return value;
            }
          );
          this.setState({ selectedVehicleTickets: emptyFalseArray });
          this.setState({ displayReservationResults: true });
          this.setState({ displayItineraries: true });
          this.setState({ loadingSpinner: false });

          if (personTickets.length === 0 && vehicleTickets.length === 0) {
            this.setState({ displayReservationResults: false });
            this.setState({ displayItineraries: false });
            ToastStore.error(translations[this.props.lang]["No Data"], 5000);
          }

          let firstNewTicketIndex = null;
          for (let i = 0; i < personTickets.length; i++) {
            firstNewTicketIndex = i;
            break;
          }

          this.setState({ firstNewTicketIndex });
          this.setState({
            isPersonSelectAllToggled: false,
          });
          this.setState({
            isVehicleSelectAllToggled: false,
          });

          if (personTickets.length > 0) {
            if (personTickets[0].ItineraryID === "0") {
              let bookIDArray = [];
              let bookIDVehicleArray = [];
              let pass = [];
              let veh = [];
              for (let i = 0; i < personTickets.length; i++) {
                bookIDArray.push(personTickets[i].BookID);
                pass.push(personTickets[i]);
              }

              for (let i = 0; i < vehicleTickets.length; i++) {
                bookIDVehicleArray.push(vehicleTickets[i].BookID);
                veh.push(vehicleTickets[i]);
              }

              const headerData = {
                userid: this.state.credentials.userid,
                lang: this.props.lang,
                Password: this.state.credentials.Password,
                UserName: this.state.credentials.UserName,
                itineraryID: this.state.selectedItineraryID,
                sailID: this.state.selectedSailID,
                bookingNumber: this.state.reservationNumber.trim(),
                companyCode: this.state.companyAbbreviation,
                bookIDArray: bookIDArray,
                bookIDVehicleArray: bookIDVehicleArray,
                passArray: pass,
                vehArray: veh,
                tripData: tripData,
              };
              this.setState({ loadingSpinner: true });
              axios.post(B2B_PROXY + "/openPost", headerData).then((res) => {
                this.setState({ loadingSpinner: false });
              });
            }
          } else {
            if (vehicleTickets[0].ItineraryID === "0") {
              let bookIDArray = [];
              let bookIDVehicleArray = [];
              let pass = [];
              let veh = [];
              for (let i = 0; i < personTickets.length; i++) {
                bookIDArray.push(personTickets[i].BookID);
                pass.push(personTickets[i]);
              }

              for (let i = 0; i < vehicleTickets.length; i++) {
                bookIDVehicleArray.push(vehicleTickets[i].BookID);
                veh.push(vehicleTickets[i]);
              }

              const headerData = {
                userid: this.state.credentials.userid,
                lang: this.props.lang,
                Password: this.state.credentials.Password,
                UserName: this.state.credentials.UserName,
                itineraryID: this.state.selectedItineraryID,
                sailID: this.state.selectedSailID,
                bookingNumber: this.state.reservationNumber.trim(),
                companyCode: this.state.companyAbbreviation,
                bookIDArray: bookIDArray,
                bookIDVehicleArray: bookIDVehicleArray,
                passArray: pass,
                vehArray: veh,
                tripData: tripData,
              };
              this.setState({ loadingSpinner: true });
              axios.post(B2B_PROXY + "/openPost", headerData).then((res) => {
                this.setState({ loadingSpinner: false });
              });
            }
          }
        });
    }
  };

  onClickManualEntryPassenger = () => {
    this.setState({ manualEntryPassenger: true });
    this.setState({ manualEntryVehicle: false });
  };

  onClickManualEntryVehicle = () => {
    this.setState({ manualEntryPassenger: false });
    this.setState({ manualEntryVehicle: true });
  };

  onCloseManualEntry = () => {
    this.setState({ isManualEntryOpen: false });
  };

  onCloseEditTicket = () => {
    this.setState({ isEditTicketOpen: false });
  };

  onClickClearButton = () => {
    this.setState({ displayReservationResults: false });
    this.setState({ selectedItineraryID: "" });
    this.setState({ companyAbbreviation: "" });
    this.setState({ ticketNumber: "" });
    this.setState({ reservationNumber: "" });
    this.setState({ personTickets: [] });
    this.setState({ vehicleTickets: [] });
    this.setState({ selectedItineraryIndex: null });
  };

  onClickHistoryButton = () => {
    this.setState({ shouldUpdateHistory: false }, () => {
      if (this.state.displayReservationResults) {
        this.setState({ isHistoryModalOpen: true });
        if (this.state.historyType !== "") {
          this.setState({ loadingSpinner: true });
          const headerData = {
            userGroupCode: this.state.credentials.userid,
            lang: this.props.lang,
            password: this.state.credentials.Password,
            code: this.state.credentials.UserName,
            companyAbbreviation: this.state.companyAbbreviation,
            bookingNumber: this.state.reservationNumber.trim(),
            historyType: this.state.historyType,
            selectedCheckpoint: this.state.selectedCheckpoint,
          };
          axios
            .post(B2B_PROXY + "/confirmationHistory", headerData)
            .then((res) => {
              const reservationHistory = res.data.map((obj) => ({
                Company: obj[0].Company,
                IMO: obj[0].IMO,
                Vesselname: obj[0].Vesselname,
                DepartureDate: obj[0].DepartureDate,
                BookingNumber: obj[0].BookingNumber,
                TicketNumber: obj[0].TicketNumber,
                Type: obj[0].Type,
                SurnamePlates: obj[0].SurnamePlates,
                Name: obj[0].Name,
                InsertDate: obj[0].InsertDate,
                DeleteDate: obj[0].DeleteDate,
                InsertUser: obj[0].InsertUser,
                DeleteUser: obj[0].DeleteUser,
                BookId: obj[0].BookId,
                BookIdAnalysis: obj[1],
              }));
              this.setState({ reservationHistory }, () => {
                this.setState({ shouldUpdateHistory: true });
              });

              axios
                .post(B2B_PROXY + "/checkPointHistory", headerData)
                .then((res) => {
                  this.setState({ checkValidity: res.data });
                  axios
                    .post(B2B_PROXY + "/checkpoints", this.state.credentials)
                    .then((res) => {
                      if (res.data[0] === "000") {
                        if (Array.isArray(res.data[2].CheckPoint) && res.data[2].CheckPoint.length) {
                          this.setState({
                            CheckPoints: res.data[2].CheckPoint,
                          });
                        }
                      }
                    });
                });

              this.setState({ loadingSpinner: false });
            });
        }
      }
    });
  };

  printReservationHistoryToXlsx() {
    if (this.state.isHistoryModalOpen) {
      this.setState({ loadingSpinner: true });

      let parsedCheckValidity = JSON.parse(
        JSON.stringify(this.state.checkValidity)
      );

      for (let i = 0; i < parsedCheckValidity.length; i++) {
        let checkpointName = "";
        for (let x = 0; x < this.state.CheckPoints.length; x++) {
          if (
            this.state.CheckPoints[x]["@attributes"].Id ==
            parsedCheckValidity[i].CheckPointId
          ) {
            checkpointName =
              this.state.CheckPoints[x]["@attributes"].Description;
          }
        }
        parsedCheckValidity[i].CheckPointId =
          "Check Validity - Checkpoint: " + checkpointName;

        let allowedDateTime = parsedCheckValidity[i].ValidationDate;
        let allowedDateTimeArray = allowedDateTime.split(" ");
        let allowedDateArray = allowedDateTimeArray[0].split("-");

        let allowedDateString =
          allowedDateArray[2] +
          "/" +
          allowedDateArray[1] +
          "/" +
          allowedDateArray[0] +
          " " +
          allowedDateTimeArray[1];

        parsedCheckValidity[i].ValidationDate = allowedDateString;
      }

      let headerData = {
        datatoexport: this.state.reservationHistory,
        checkValidity: parsedCheckValidity,
      };
      axios
        .post(B2B_PROXY + "/HistoryXlsx", headerData, { responseType: "blob" })
        .then((res) => {
          this.setState({ loadingSpinner: false });
          const blobUrl = URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = blobUrl;
          link.setAttribute("download", this.state.reservationNumber + ".xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
        });
    }
  }

  lockTrip = () => {
    if (this.state.selectedItineraryID !== "") {
      this.setState({ loadingSpinner: true });
      const headerData = {
        userid: this.state.credentials.userid,
        lang: this.props.lang,
        Password: this.state.credentials.Password,
        UserName: this.state.credentials.UserName,
        itineraryID: this.state.selectedItineraryID,
        sailID: this.state.selectedSailID,
      };
      axios.post(B2B_PROXY + "/lockUnlockTrip", headerData).then((res) => {
        if (res.data.statusCode === "000") {
          ToastStore.success(
            translations[this.props.lang][
              "You have successfully locked the selected trip."
            ],
            5000
          );
        } else {
          ToastStore.error(res.data.statusMessage, 5000);
        }
        this.setState({ loadingSpinner: false });
      });
    }
  };

  deleteBooking = () => {
    if (this.state.selectedItineraryID !== "") {
      this.setState({ loadingSpinner: true });
      const headerData = {
        userid: this.state.credentials.userid,
        lang: this.props.lang,
        Password: this.state.credentials.Password,
        UserName: this.state.credentials.UserName,
        itineraryID: this.state.selectedItineraryID,
        sailID: this.state.selectedSailID,
        bookingNumber: this.state.reservationNumber.trim(),
        bookIDSToDelete: this.state.bookIDsForDeleteAll,
        bookIDSVehToDelete: this.state.bookIDsVehForDeleteAll,
      };
      axios.post(B2B_PROXY + "/deleteBooking", headerData).then((res) => {
        if (res.data.statusCode === "000") {
          ToastStore.success(
            translations[this.props.lang][
              "You have successfully deleted this reservation."
            ],
            5000
          );
        } else {
          ToastStore.error(res.data.statusMessage, 5000);
        }
        this.onClickClearButton();
        this.setState({ loadingSpinner: false });
      });
    }
  };

  onClickManualEntryButton = () => {
    if (this.state.companyAbbreviation !== "")
      this.setState({ isManualEntryOpen: true });
  };

  onClickEditTicketButton = () => {
    if (this.state.hasSelectedTickets)
      this.setState({ isEditTicketOpen: true });
  };

  onClickReloadRoutesButton = () => {
    this.setState({ loadingSpinner: true });
    this.setState({ displayReservationResults: false });
    this.setState({ selectedItineraryID: "" });
    this.setState({ companyAbbreviation: "" });
    this.setState({ ticketNumber: "" });
    this.setState({ reservationNumber: "" });
    this.setState({ personTickets: [] });
    this.setState({ vehicleTickets: [] });
    this.setState({ selectedItineraryIndex: null });

    if (this.state.DItineraries) {
      this.setState({ loadingSpinner: true });
      this.setState({ displayReservationResults: false });
      this.setState({ selectedItineraryID: "" });
      this.setState({ companyAbbreviation: "" });
      this.setState({ ticketNumber: "" });
      this.setState({ reservationNumber: "" });
      this.setState({ personTickets: [] });
      this.setState({ vehicleTickets: [] });
      this.setState({ selectedItineraryIndex: null });
      axios
        .post(B2B_PROXY + "/ditineraries", this.state.credentials)
        .then((res) => {
          let itinerariesMap = [];
          if (res.data.statusData.StatusCode === "000") {
            itinerariesMap = res.data.map((obj) => ({
              ItineraryID: obj.ItineraryID,
              SailID: obj.SailID,
              DeparturePortDescription: obj.DeparturePortDescription,
              VesselName: obj.VesselName,
              CompanyDescription: obj.CompanyDescription,
              CompanyCode: obj.CompanyCode,
              ArrivalPortDescription: obj.ArrivalPortDescription,
              DepartureDate: obj.DepartureDate,
              DepartureTime: obj.DepartureTime,
              ArrivalDate: obj.ArrivalDate,
              ArrivalTime: obj.ArrivalTime,
            }));
            this.setState({ itineraries: itinerariesMap });
          } else {
            this.setState({ itineraries: itinerariesMap });
            this.setState({ loadingSpinner: false });
            ToastStore.error(res.data.statusData.StatusMessage, 5000);
          }
          this.setState({ loadingSpinner: false });
        })
        .catch(() => {
          ToastStore.error("Network Error. Please try again.");
          this.setState({ loadingSpinner: false });
        });
    } else if (this.state.CItineraries) {
      this.setState({ loadingSpinner: true });
      this.setState({ displayReservationResults: false });
      this.setState({ selectedItineraryID: "" });
      this.setState({ companyAbbreviation: "" });
      this.setState({ ticketNumber: "" });
      this.setState({ reservationNumber: "" });
      this.setState({ personTickets: [] });
      this.setState({ vehicleTickets: [] });
      this.setState({ selectedItineraryIndex: null });
      axios
        .post(B2B_PROXY + "/citineraries", this.state.credentials)
        .then((res) => {
          if (res.data[0].hasOwnProperty("StatusMessage")) {
            ToastStore.error(res.data.StatusMessage);
          } else {
            const itinerariesMap = res.data.map((obj) => ({
              ItineraryID: obj.ItineraryID,
              SailID: obj.SailID,
              DeparturePortDescription: obj.DeparturePortDescription,
              VesselName: obj.VesselName,
              CompanyDescription: obj.CompanyDescription,
              CompanyCode: obj.CompanyCode,
              ArrivalPortDescription: obj.ArrivalPortDescription,
              DepartureDate: obj.DepartureDate,
              DepartureTime: obj.DepartureTime,
              ArrivalDate: obj.ArrivalDate,
              ArrivalTime: obj.ArrivalTime,
              AvailablePassengers: obj.AvailablePassengers,
              AvailableVehicles: obj.AvailableVehicles,
              OccupiedPassengers: obj.OccupiedPassengers,
              OccupiedVehicles: obj.OccupiedVehicles,
              CheckedInPassengers: obj.CheckedInPassengers,
              CheckedInVehicles: obj.CheckedInVehicles,
              RemainderPassengers: obj.RemainderPassengers,
              RemainderVehicles: obj.RemainderVehicles,
              ConfirmedPassengerCounter: obj.ConfirmedPassengerCounter,
              ConfirmedVehicleCounter: obj.ConfirmedVehicleCounter,
              ConfirmedPassengerRemaining: obj.ConfirmedPassengerRemaining,
              ConfirmedVehicleRemaining: obj.ConfirmedVehicleRemaining,
              ConfirmedPassengerRemainingThreshold:
                obj.ConfirmedPassengerRemainingThreshold,
              ConfirmedVehicleRemainingThreshold:
                obj.ConfirmedVehicleRemainingThreshold,
            }));

            this.setState({ itineraries: itinerariesMap });
          }
          this.setState({ loadingSpinner: false });
        })
        .catch(() => {
          ToastStore.error("Network Error. Please try again.");
          this.setState({ loadingSpinner: false });
        });
    } else {
      this.setState({ CItineraries: false });
      this.setState({ DItineraries: false });
      this.setState({ loadingSpinner: true });
      this.setState({ displayReservationResults: false });
      this.setState({ selectedItineraryID: "" });
      this.setState({ companyAbbreviation: "" });
      this.setState({ ticketNumber: "" });
      this.setState({ reservationNumber: "" });
      this.setState({ personTickets: [] });
      this.setState({ vehicleTickets: [] });
      this.setState({ selectedItineraryIndex: null });
      axios
        .post(B2B_PROXY + "/itineraryInfo", this.state.credentials)
        .then((res) => {
          var removeDuplicateCompanyAbbreviations = [];
          var companyAbbreviations = new Set();
          let itinerariesMap = [];
          if (res.data.statusData.StatusCode === "000") {
            itinerariesMap = res.data.itineraryInfo.map((obj) => ({
              ItineraryID: obj.ItineraryID,
              SailID: obj.SailID,
              DeparturePortDescription: obj.DeparturePortDescription,
              VesselName: obj.VesselName,
              CompanyDescription: obj.CompanyDescription,
              CompanyCode: obj.CompanyCode,
              ArrivalPortDescription: obj.ArrivalPortDescription,
              DepartureDate: obj.DepartureDate,
              DepartureTime: obj.DepartureTime,
              ArrivalDate: obj.ArrivalDate,
              ArrivalTime: obj.ArrivalTime,
              AvailablePassengers: obj.AvailablePassengers,
              AvailableVehicles: obj.AvailableVehicles,
              OccupiedPassengers: obj.OccupiedPassengers,
              OccupiedVehicles: obj.OccupiedVehicles,
              CheckedInPassengers: obj.CheckedInPassengers,
              CheckedInVehicles: obj.CheckedInVehicles,
              RemainderPassengers: obj.RemainderPassengers,
              RemainderVehicles: obj.RemainderVehicles,
              ConfirmedPassengerCounter: obj.ConfirmedPassengerCounter,
              ConfirmedVehicleCounter: obj.ConfirmedVehicleCounter,
              ConfirmedPassengerRemaining: obj.ConfirmedPassengerRemaining,
              ConfirmedVehicleRemaining: obj.ConfirmedVehicleRemaining,
              ConfirmedPassengerRemainingThreshold:
                obj.ConfirmedPassengerRemainingThreshold,
              ConfirmedVehicleRemainingThreshold:
                obj.ConfirmedVehicleRemainingThreshold,
            }));

            for (let i = 0; i < itinerariesMap.length; i++) {
              if (!companyAbbreviations.has(itinerariesMap[i].CompanyCode)) {
                removeDuplicateCompanyAbbreviations.push([
                  itinerariesMap[i].CompanyCode,
                  itinerariesMap[i],
                ]);
                companyAbbreviations.add(itinerariesMap[i].CompanyCode);
              }
            }
            this.setState({
              noDuplicateCompanyAbbreviations:
                removeDuplicateCompanyAbbreviations,
            });
            this.setState({ itineraries: itinerariesMap });
            this.setState({ loadingSpinner: false });
          } else {
            this.setState({
              noDuplicateCompanyAbbreviations:
                removeDuplicateCompanyAbbreviations,
            });
            this.setState({ itineraries: itinerariesMap });
            this.setState({ loadingSpinner: false });
            ToastStore.error(res.data.statusData.StatusMessage, 5000);
          }
        })
        .catch(() => {
          ToastStore.error(
            translations[this.props.lang]["Network Error"],
            5000
          );
          this.setState({ loadingSpinner: false });
        });
    }
  };

  issueBoardingPasses = (thermalPrintState) => {
    this.setState({ loadingSpinner: true });
    this.setState({ hasPersonVouchers: false });
    let tickets = [];
    let emails = [];
    let voucherArray = [];
    let bookIDArray = [];
    let firstVehicleIndex = null;

    for (let i = 0; i < this.state.personTickets.length; i++) {
      if (this.state.selectedPersonTickets[i]) {
        emails.push({
          BoardId: this.state.personTickets[i].BoardID,
          EMAIL: this.state.ticketEmails[i],
          TicketNumber: this.state.personTickets[i].TicketNumber,
        });
        tickets.push({ ticketemail: this.state.personTickets[i] });
        voucherArray.push(this.state.personTickets[i]);
        bookIDArray.push(this.state.personTickets[i].BookID);
        this.setState({ hasPersonVouchers: true });
        if (this.state.isMRZMandatory === "1" && this.state.personTickets[i].IsMRZScanned !== "1") {
          ToastStore.error(
            translations[this.props.lang][
              "MRZ scanning is required. Please parse MRZ for the selected passengers."
            ] || "MRZ scanning is required. Please parse MRZ for the selected passengers.",
            5000
          );
          this.setState({ 
            loadingSpinner: false,
            isEditTicketOpen: true,
            editPerson: true,
            editData: this.state.personTickets[i]
          });
          return;
        }
        if (this.state.personTickets[i].BoardStatus === "A") {
          ToastStore.error(
            translations[this.props.lang][
              "Cannot issue boarding pass for an already printed ticket"
            ],
            5000
          );
          this.setState({ loadingSpinner: false });
          return;
        }
        if (this.state.personTickets[i].ConfirmationStatus === "C") {
          ToastStore.error(
            translations[this.props.lang][
              'Cannot issue boarding pass. Confirmation status is "C"'
            ],
            5000
          );
          this.setState({ loadingSpinner: false });
          return;
        }
      }
    }
    
    if (emails.length > 0) {
      firstVehicleIndex = emails.length;
    } else {
      firstVehicleIndex = 0;
    }

    for (let i = 0; i < this.state.vehicleTickets.length; i++) {
      if (this.state.selectedVehicleTickets[i]) {
        emails.push({
          BoardId: this.state.vehicleTickets[i].BoardID,
          EMAIL: this.state.ticketVehicleEmails[i],
          TicketNumber: this.state.vehicleTickets[i].TicketNumber,
        });
        tickets.push({ ticketemail: this.state.vehicleTickets[i] });
        voucherArray.push(this.state.vehicleTickets[i]);
        bookIDArray.push(this.state.vehicleTickets[i].BookID);
        if (this.state.vehicleTickets[i].BoardStatus === "A") {
          ToastStore.error(
            translations[this.props.lang][
              "Cannot issue boarding pass for an already printed ticket"
            ],
            5000
          );
          this.setState({ loadingSpinner: false });
          return;
        }
        if (this.state.vehicleTickets[i].ConfirmationStatus === "C") {
          ToastStore.error(
            translations[this.props.lang][
              'Cannot issue boarding pass. Confirmation status is "C"'
            ],
            5000
          );
          this.setState({ loadingSpinner: false });
          return;
        }
      }
    }

    this.setState({ boardingCardVouchers: voucherArray });

    if (
      voucherArray.length > 0 &&
      !this.state.disableIssueBoardingPassesButton || voucherArray.length > 0 && thermalPrintState
    ) {

      const postUrl = thermalPrintState ? "/thermalPrint" : "/checkinCP";

      axios
        .post(B2B_PROXY + postUrl, {
          ticket: tickets,
          ITINID: this.state.selectedItineraryID,
          emailperTick: emails,
          ITINER: this.state.itineraries[this.state.selectedItineraryIndex],
          pnr: this.state.reservationNumber,
          userid: this.state.credentials.userid,
          UserName: this.state.credentials.UserName,
          Password: this.state.credentials.Password,
          lang: this.props.lang,
          bookIDArray: bookIDArray,
          firstVehicleIndex: firstVehicleIndex,
        })
        .then((res) => {
          this.setState({ loadingSpinner: false });
          if (res.data.statusCode === "000") {
            const IssueTickets = res.data.ResponseStatus.map((obj) => ({
              Status: obj.Status,
              Message: obj.Message,
              Blob: obj.BlobData,
              PdfBase64: obj.PdfBase64,
            }));
            this.setState({ IssueTickets });
            this.setState({ displayVouchers: !thermalPrintState });
            this.setState({ printedBoardIds: res.data.printedBoardIds });
            ToastStore.success(
              translations[this.props.lang][
                "Your Boarding Passes have been issued."
              ],
              5000
            );
            this.fetchReservation();

            if (thermalPrintState) {
              IssueTickets.forEach((ticket, index) => {
                const decodedBlob = atob(ticket.Blob);
                this.writeToSelectedPrinter(decodedBlob);
              })
            }
          } else {
            ToastStore.error(res.data.ResponseStatus.StatusMessage, 5000);
          }
        });
    } else {
      this.setState({ loadingSpinner: false });
    }
  };

  cancelBoardingPasses = () => {
    this.setState({ loadingSpinner: true });
    this.setState({ hasPersonVouchers: false });
    let bookIDArray = [];
    let mobileArray = [];
    let emailArray = [];
    let bookIDVehicleArray = [];
    let mobileVehicleArray = [];
    let emailVehicleArray = [];
    let voucherArray = [];

    for (let i = 0; i < this.state.personTickets.length; i++) {
      if (this.state.selectedPersonTickets[i]) {
        bookIDArray.push(this.state.personTickets[i].BookID);
        mobileArray.push(this.state.ticketPhoneNumbers[i]);
        emailArray.push(this.state.ticketEmails[i]);
        voucherArray.push(this.state.personTickets[i]);
        this.setState({ hasPersonVouchers: true });
      }
    }

    for (let i = 0; i < this.state.vehicleTickets.length; i++) {
      if (this.state.selectedVehicleTickets[i]) {
        bookIDVehicleArray.push(this.state.vehicleTickets[i].BookID);
        mobileVehicleArray.push(this.state.ticketVehiclePhoneNumbers[i]);
        emailVehicleArray.push(this.state.ticketVehicleEmails[i]);
        voucherArray.push(this.state.vehicleTickets[i]);
      }
    }

    this.setState({ boardingCardVouchers: voucherArray });

    if (voucherArray.length > 0) {
      axios
        .post(B2B_PROXY + "/cancelBoardingPasses", {
          userid: this.state.credentials.userid,
          lang: this.state.credentials.lang,
          Password: this.state.credentials.Password,
          UserName: this.state.credentials.UserName,
          bookIDArray: bookIDArray,
          mobileArray: mobileArray,
          emailArray: emailArray,
          bookIDVehicleArray: bookIDVehicleArray,
          mobileVehicleArray: mobileVehicleArray,
          emailVehicleArray: emailVehicleArray,
          itineraryID: this.state.selectedItineraryID,
        })
        .then((res) => {
          this.setState({ loadingSpinner: false });
          if (res.data.confirmCode === "000") {
            this.setState({ displayVouchers: true });
            this.setState({ hasCancelledTickets: true });
            ToastStore.success(
              translations[this.props.lang][
                "You have successfully cancelled your boarding passes."
              ],
              5000
            );
            this.fetchReservation();
          } else {
            ToastStore.error(res.data.StatusMessage, 5000);
          }
        });
    } else {
      this.setState({ loadingSpinner: false });
    }
  };

  onCloseDisplayVouchers = () => {
    this.setState({ displayVouchers: false });
    //this.setState({ hasCancelledTickets: false});
    setTimeout(
      function () {
        this.setState({ hasCancelledTickets: false });
      }.bind(this),
      3000
    );
  };

  onCloseHistoryModal = () => {
    this.setState({ isHistoryModalOpen: false });
  };

  onClickReportsButton = () => {
    this.setState({ OpenReports: !this.state.OpenReports });
  };

  onClickPrintSelection = () => {
    this.setState({ OpenPrinters: !this.state.OpenPrinters });
  }

  changeSelectedDevice = (e) => {
    const selectedDevice = this.state.devices.find(device => device.uid === e.target.value);
    this.setState({ selectedDevice: selectedDevice });
  }

  onChangeCompany = (company) => {
    this.setState({ companyAbbreviation: company });
  };

  onChangeCompanyManualEntry = (event) => {};

  handleChangeOfCheckpoint = (event) => {
    let fieldValue = event.target.value;
    this.setState({ selectedCheckpoint: fieldValue }, () => {
      this.onClickHistoryButton();
    });
  };

  handleItineraries = (callType) => {
    if (callType === 2 && !this.state.DItineraries) {
      this.setState({ CItineraries: false });
      this.setState({ DItineraries: !this.state.DItineraries }, () => {
        this.setState({ loadingSpinner: true });
        this.setState({ displayReservationResults: false });
        this.setState({ selectedItineraryID: "" });
        this.setState({ companyAbbreviation: "" });
        this.setState({ ticketNumber: "" });
        this.setState({ reservationNumber: "" });
        this.setState({ personTickets: [] });
        this.setState({ vehicleTickets: [] });
        this.setState({ selectedItineraryIndex: null });
        axios
          .post(B2B_PROXY + "/ditineraries", this.state.credentials)
          .then((res) => {
            let itinerariesMap = [];
            if (res.data.statusData.StatusCode === "000") {
              itinerariesMap = res.data.map((obj) => ({
                ItineraryID: obj.ItineraryID,
                SailID: obj.SailID,
                DeparturePortDescription: obj.DeparturePortDescription,
                VesselName: obj.VesselName,
                CompanyDescription: obj.CompanyDescription,
                CompanyCode: obj.CompanyCode,
                ArrivalPortDescription: obj.ArrivalPortDescription,
                DepartureDate: obj.DepartureDate,
                DepartureTime: obj.DepartureTime,
                ArrivalDate: obj.ArrivalDate,
                ArrivalTime: obj.ArrivalTime,
              }));
              this.setState({ itineraries: itinerariesMap });
              this.setState({ loadingSpinner: false });
            } else {
              this.setState({ itineraries: itinerariesMap });
              this.setState({ loadingSpinner: false });
              ToastStore.error(res.data.statusData.StatusMessage, 5000);
            }
          })
          .catch(() => {
            ToastStore.error("Network Error. Please try again.");
            this.setState({ loadingSpinner: false });
          });
      });
    } else if (callType === 1 && !this.state.CItineraries) {
      this.setState({ CItineraries: !this.state.CItineraries });
      this.setState({ DItineraries: false }, () => {
        this.setState({ loadingSpinner: true });
        this.setState({ displayReservationResults: false });
        this.setState({ selectedItineraryID: "" });
        this.setState({ companyAbbreviation: "" });
        this.setState({ ticketNumber: "" });
        this.setState({ reservationNumber: "" });
        this.setState({ personTickets: [] });
        this.setState({ vehicleTickets: [] });
        this.setState({ selectedItineraryIndex: null });
        axios
          .post(B2B_PROXY + "/citineraries", this.state.credentials)
          .then((res) => {
            if (res.data[0].hasOwnProperty("StatusMessage")) {
              ToastStore.error(res.data[0].StatusMessage);
            } else {
              const itinerariesMap = res.data.map((obj) => ({
                ItineraryID: obj.ItineraryID,
                SailID: obj.SailID,
                DeparturePortDescription: obj.DeparturePortDescription,
                VesselName: obj.VesselName,
                CompanyDescription: obj.CompanyDescription,
                CompanyCode: obj.CompanyCode,
                ArrivalPortDescription: obj.ArrivalPortDescription,
                DepartureDate: obj.DepartureDate,
                DepartureTime: obj.DepartureTime,
                ArrivalDate: obj.ArrivalDate,
                ArrivalTime: obj.ArrivalTime,
                AvailablePassengers: obj.AvailablePassengers,
                AvailableVehicles: obj.AvailableVehicles,
                OccupiedPassengers: obj.OccupiedPassengers,
                OccupiedVehicles: obj.OccupiedVehicles,
                CheckedInPassengers: obj.CheckedInPassengers,
                CheckedInVehicles: obj.CheckedInVehicles,
                RemainderPassengers: obj.RemainderPassengers,
                RemainderVehicles: obj.RemainderVehicles,
                ConfirmedPassengerCounter: obj.ConfirmedPassengerCounter,
                ConfirmedVehicleCounter: obj.ConfirmedVehicleCounter,
                ConfirmedPassengerRemaining: obj.ConfirmedPassengerRemaining,
                ConfirmedVehicleRemaining: obj.ConfirmedVehicleRemaining,
                ConfirmedPassengerRemainingThreshold:
                  obj.ConfirmedPassengerRemainingThreshold,
                ConfirmedVehicleRemainingThreshold:
                  obj.ConfirmedVehicleRemainingThreshold,
              }));
              this.setState({ itineraries: itinerariesMap });
            }
            this.setState({ loadingSpinner: false });
          })
          .catch(() => {
            ToastStore.error("Network Error. Please try again.");
            this.setState({ loadingSpinner: false });
          });
      });
    } else {
      this.setState({ CItineraries: false });
      this.setState({ DItineraries: false });
      this.setState({ loadingSpinner: true });
      this.setState({ displayReservationResults: false });
      this.setState({ selectedItineraryID: "" });
      this.setState({ companyAbbreviation: "" });
      this.setState({ ticketNumber: "" });
      this.setState({ reservationNumber: "" });
      this.setState({ personTickets: [] });
      this.setState({ vehicleTickets: [] });
      this.setState({ selectedItineraryIndex: null });
      axios
        .post(B2B_PROXY + "/itineraryInfo", this.state.credentials)
        .then((res) => {
          var removeDuplicateCompanyAbbreviations = [];
          var companyAbbreviations = new Set();
          let itinerariesMap = [];
          if (res.data.statusData.StatusCode === "000") {
            itinerariesMap = res.data.itineraryInfo.map((obj) => ({
              ItineraryID: obj.ItineraryID,
              SailID: obj.SailID,
              DeparturePortDescription: obj.DeparturePortDescription,
              VesselName: obj.VesselName,
              CompanyDescription: obj.CompanyDescription,
              CompanyCode: obj.CompanyCode,
              ArrivalPortDescription: obj.ArrivalPortDescription,
              DepartureDate: obj.DepartureDate,
              DepartureTime: obj.DepartureTime,
              ArrivalDate: obj.ArrivalDate,
              ArrivalTime: obj.ArrivalTime,
              AvailablePassengers: obj.AvailablePassengers,
              AvailableVehicles: obj.AvailableVehicles,
              OccupiedPassengers: obj.OccupiedPassengers,
              OccupiedVehicles: obj.OccupiedVehicles,
              CheckedInPassengers: obj.CheckedInPassengers,
              CheckedInVehicles: obj.CheckedInVehicles,
              RemainderPassengers: obj.RemainderPassengers,
              RemainderVehicles: obj.RemainderVehicles,
              ConfirmedPassengerCounter: obj.ConfirmedPassengerCounter,
              ConfirmedVehicleCounter: obj.ConfirmedVehicleCounter,
              ConfirmedPassengerRemaining: obj.ConfirmedPassengerRemaining,
              ConfirmedVehicleRemaining: obj.ConfirmedVehicleRemaining,
              ConfirmedPassengerRemainingThreshold:
                obj.ConfirmedPassengerRemainingThreshold,
              ConfirmedVehicleRemainingThreshold:
                obj.ConfirmedVehicleRemainingThreshold,
            }));

            for (let i = 0; i < itinerariesMap.length; i++) {
              if (!companyAbbreviations.has(itinerariesMap[i].CompanyCode)) {
                removeDuplicateCompanyAbbreviations.push([
                  itinerariesMap[i].CompanyCode,
                  itinerariesMap[i],
                ]);
                companyAbbreviations.add(itinerariesMap[i].CompanyCode);
              }
            }
            this.setState({
              noDuplicateCompanyAbbreviations:
                removeDuplicateCompanyAbbreviations,
            });
            this.setState({ itineraries: itinerariesMap });
            this.setState({ loadingSpinner: false });
          } else {
            this.setState({
              noDuplicateCompanyAbbreviations:
                removeDuplicateCompanyAbbreviations,
            });
            this.setState({ itineraries: itinerariesMap });
            this.setState({ loadingSpinner: false });
            ToastStore.error(res.data.statusData.StatusMessage, 5000);
          }
        })
        .catch(() => {
          ToastStore.error(
            translations[this.props.lang]["Network Error"],
            5000
          );
          this.setState({ loadingSpinner: false });
        });
    }
  };


  render() {
    return (
      <div className="d-md-flex d-lg-block flex-wrap col-md-12 mt-4">
        <Col md={8} sm={12}>
          <FetchItineraries
            handleClick={this.handleClickOnItinerary}
            itineraries={this.state.itineraries}
            selectedItineraryIndex={this.state.selectedItineraryIndex}
            lang={this.props.lang}
            handleItineraries={this.handleItineraries}
            CItineraries={this.state.CItineraries}
            DItineraries={this.state.DItineraries}
          />
          <SearchReservation
            itineraries={this.state.itineraries}
            companyAbbreviation={this.state.companyAbbreviation}
            ticketNumber={this.state.ticketNumber}
            reservationNumber={this.state.reservationNumber}
            noDuplicateCompanyAbbreviations={
              this.state.noDuplicateCompanyAbbreviations
            }
            personTickets={this.state.personTickets}
            vehicleTickets={this.state.vehicleTickets}
            fetchReservation={this.fetchReservation}
            onChangeCompany={this.onChangeCompany}
            handleChangeOfInput={this.handleChangeOfInputSearchFields}
            validateSearch={this.validateSearch}
            lang={this.props.lang}
          />
        </Col>
        <Col md={4} sm={12} className="right">
          <Menu
            personBoardingPassesIssued={this.state.personBoardingPassesIssued}
            checkedInPassengers={this.state.checkedInPassengers}
            vehicleBoardingPassesIssued={this.state.vehicleBoardingPassesIssued}
            checkedInVehicles={this.state.checkedInVehicles}
            confirmedPassengers={this.state.confirmedPassengers}
            confirmedVehicles={this.state.confirmedVehicles}
            onClickPrintButton={this.issueBoardingPasses}
            onClickClearButton={this.onClickClearButton}
            onClickCancelButton={this.cancelBoardingPasses}
            onClickReloadRoutesButton={this.onClickReloadRoutesButton}
            onClickReportsButton={this.onClickReportsButton}
            onClickPrintSelection={this.onClickPrintSelection}
            onClickHistoryButton={this.onClickHistoryButton}
            onClickManualEntryButton={this.onClickManualEntryButton}
            onClickEditTicketButton={this.onClickEditTicketButton}
            lockTrip={this.lockTrip}
            deleteBooking={this.deleteBooking}
            lang={this.props.lang}
          />
        </Col>
        <Col md={8} sm={12} xs={12}>
          <ReservationDetails
            isMRZMandatory={this.state.isMRZMandatory}
            displayReservationResults={this.state.displayReservationResults}
            personTickets={this.state.personTickets}
            vehicleTickets={this.state.vehicleTickets}
            selectedPersonTickets={this.state.selectedPersonTickets}
            selectedVehicleTickets={this.state.selectedVehicleTickets}
            isPersonSelectAllToggled={this.state.isPersonSelectAllToggled}
            isVehicleSelectAllToggled={this.state.isVehicleSelectAllToggled}
            handlePersonCheckboxChange={this.handlePersonCheckboxChange}
            handleVehicleCheckboxChange={this.handleVehicleCheckboxChange}
            handlePersonSelectAllButton={this.handlePersonSelectAllButton}
            handleVehicleSelectAllButton={this.handleVehicleSelectAllButton}
            myRef={this.myRef}
            lang={this.props.lang}
            reservationNumber={this.state.reservationNumber}
            ticketEmails={this.state.ticketEmails}
            ticketPhoneNumbers={this.state.ticketPhoneNumbers}
            ticketVehicleEmails={this.state.ticketVehicleEmails}
            ticketVehiclePhoneNumbers={this.state.ticketVehiclePhoneNumbers}
            handleChangeOfInputTicketEmail={this.handleChangeOfInputTicketEmail}
            handleChangeOfInputTicketPhone={this.handleChangeOfInputTicketPhone}
            handleChangeOfInputTicketVehicleEmail={
              this.handleChangeOfInputTicketVehicleEmail
            }
            handleChangeOfInputTicketVehiclePhone={
              this.handleChangeOfInputTicketVehiclePhone
            }
          />
        </Col>
        <VoucherDisplay
          displayVouchers={this.state.displayVouchers}
          hasCancelledTickets={this.state.hasCancelledTickets}
          hasPersonVouchers={this.state.hasPersonVouchers}
          lang={this.props.lang}
          selectedDevice={this.state.selectedDevice}
          writeToSelectedPrinter={this.writeToSelectedPrinter}
          boardingCardVouchers={this.state.boardingCardVouchers}
          onCloseDisplayVouchers={this.onCloseDisplayVouchers}
          printedBoardIds={this.state.printedBoardIds}
          IssueTickets={this.state.IssueTickets}
        />
        <History
          isHistoryModalOpen={this.state.isHistoryModalOpen}
          onCloseHistoryModal={this.onCloseHistoryModal}
          reservationHistory={this.state.reservationHistory}
          historyType={this.state.historyType}
          shouldUpdateHistory={this.state.shouldUpdateHistory}
          printReservationHistoryToXlsx={this.printReservationHistoryToXlsx}
          handleChangeOfHistoryRadioButtons={
            this.handleChangeOfHistoryRadioButtons
          }
          handleChangeOfCheckpoint={this.handleChangeOfCheckpoint}
          CheckPoints={this.state.CheckPoints}
          credentials={this.state.credentials}
          lang={this.props.lang}
          personTickets={this.state.personTickets}
          vehicleTickets={this.state.vehicleTickets}
          checkValidity={this.state.checkValidity}
          selectedCheckpoint={this.state.selectedCheckpoint}
        />
        {this.state.isManualEntryOpen ? (
          <Col md={8} sm={12}>
            <ManualEntry
              itineraries={this.state.itineraries}
              ItineraryID={this.state.selectedItineraryID}
              SailID={this.state.selectedSailID}
              isManualEntryOpen={this.state.isManualEntryOpen}
              onCloseManualEntry={this.onCloseManualEntry}
              companyAbbreviation={this.state.companyAbbreviation}
              manualEntryPassenger={this.state.manualEntryPassenger}
              manualEntryVehicle={this.state.manualEntryVehicle}
              manualEntryRadioValue={this.state.manualEntryRadioValue}
              handleChangeOfManualEntryRadioButton={
                this.handleChangeOfManualEntryRadioButton
              }
              onClickManualEntryPassenger={this.onClickManualEntryPassenger}
              onClickManualEntryVehicle={this.onClickManualEntryVehicle}
              handleChangeOfInput={this.handleChangeOfInputSearchFields}
              fetchReservation={this.fetchReservation}
              lang={this.props.lang}
              userGroup={this.state.credentials.userid}
              username={this.state.credentials.UserName}
              password={this.state.credentials.Password}
            />
          </Col>
        ) : null}
        {this.state.isEditTicketOpen ? (
          <Col md={8} sm={12}>
            <EditTicket
              itineraries={this.state.itineraries}
              ItineraryID={this.state.selectedItineraryID}
              SailID={this.state.selectedSailID}
              isManualEntryOpen={this.state.isEditTicketOpen}
              onCloseManualEntry={this.onCloseEditTicket}
              companyAbbreviation={this.state.companyAbbreviation}
              manualEntryPassenger={this.state.editPerson ? true : false}
              manualEntryVehicle={!this.state.editPerson ? true : false}
              manualEntryRadioValue={this.state.manualEntryRadioValue}
              handleChangeOfManualEntryRadioButton={
                this.handleChangeOfManualEntryRadioButton
              }
              personTickets={this.state.personTickets}
              onClickManualEntryPassenger={this.onClickManualEntryPassenger}
              onClickManualEntryVehicle={this.onClickManualEntryVehicle}
              handleChangeOfInput={this.handleChangeOfInputSearchFields}
              editPerson={this.state.editPerson}
              editData={this.state.editData}
              reservationNumber={this.state.reservationNumber}
              fetchReservation={this.fetchReservation}
              lang={this.props.lang}
              userGroup={this.state.credentials.userid}
              username={this.state.credentials.UserName}
              password={this.state.credentials.Password}
              canUseMRZ={this.state.CanUseMRZ}
              port={this.props.port}
              onRequestPort={this.props.onRequestPort}
              lastScannedMRZ={this.props.lastScannedMRZ}
            />
          </Col>
        ) : null}
        <Col md={4} sm={12} className="right">
          <Reports
            ItineraryID={this.state.selectedItineraryID}
            SailID={this.state.selectedSailID}
            user={localStorage.getItem("userName")}
            id={localStorage.getItem("userId")}
            password={localStorage.getItem("password")}
            OpenReports={this.state.OpenReports}
            onClickReportsButton={this.onClickReportsButton}
          />
        </Col>
        <Col md={4} sm={12} className="right">
          <PrinterSelection
            lang={this.props.lang}
            OpenPrinters={this.state.OpenPrinters}
            onClickPrintSelection={this.onClickPrintSelection}
            writeToSelectedPrinter={this.writeToSelectedPrinter}
            selectedDevice={this.state.selectedDevice}
            changeSelectedDevice={this.changeSelectedDevice}
            devices={this.state.devices}
            canTestPrint={this.state.CanTestPrint}
          />
        </Col> 
        <Loader fullPage loading={this.state.loadingSpinner} />
        <ToastContainer
          store={ToastStore}
          className="toaster"
          lightBackground
          position={
            // @ts-ignore
            ToastContainer.POSITION.TOP_CENTER
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/MainAppContainer.js